export default function formatCurrency(
  valor: number | null | undefined,
  maximumFractionDigits = 10,
  isDolar = false,
  usarCifrao = true,
): string {
  if (valor === null || valor === undefined) {
    return '';
  }
  const formatado = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: isDolar ? 'USD' : 'BRL',
    maximumFractionDigits,
  }).format(valor);

  if (!usarCifrao) {
    return formatado.replace(/[^0-9.,-]/g, '').trim();
  }

  return formatado;
}
